let isInstalled = false;
let baseFetch = null;

function normalizeLocale(locale) {
    const normalized = String(locale || '').toLowerCase().replace('_', '-');
    const baseLocale = normalized.split('-')[0];
    if (baseLocale === 'en') {
        return 'en';
    }

    return 'uk';
}

function shouldAttachLocale(url) {
    if (typeof window === 'undefined') {
        return false;
    }

    try {
        const parsed = new URL(url, window.location.origin);
        return parsed.origin === window.location.origin && parsed.pathname.startsWith('/api/');
    } catch (e) {
        return false;
    }
}

export function installLocaleAwareFetch(getLocale) {
    if (isInstalled || typeof window === 'undefined' || typeof window.fetch !== 'function') {
        return;
    }

    baseFetch = window.fetch.bind(window);

    window.fetch = (input, init = {}) => {
        const requestUrl = input instanceof Request ? input.url : String(input);
        if (!shouldAttachLocale(requestUrl)) {
            return baseFetch(input, init);
        }

        const locale = normalizeLocale(getLocale?.());
        const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
        headers.set('X-App-Locale', locale);

        if (input instanceof Request) {
            const request = new Request(input, {headers});
            return baseFetch(request, init);
        }

        return baseFetch(input, {
            ...init,
            headers,
        });
    };

    isInstalled = true;
}
